export default {
  snackbar: {
    text: "",
    enabled: false,
  }, 
};
